var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysLine = function SvgSysLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 15 2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.776 1.5H1.224a.712.712 0 0 1-.512-.22A.764.764 0 0 1 .5.75C.5.551.576.36.712.22c.136-.141.32-.22.512-.22h12.552c.192 0 .376.079.512.22.136.14.212.331.212.53s-.076.39-.212.53a.712.712 0 0 1-.512.22Z"
  })));
};
export default SvgSysLine;